import css from 'styled-jsx/css';

const styles = css.global``;

export default styles;